import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined'
import {
  DropzoneInputProps,
  DropzoneRootProps,

} from 'react-dropzone'


type Props = {
  dragOver: boolean
  style: {
    borderColor?: string | undefined
    flex: number
    display: string
    flexDirection: 'column'
    alignItems: string
    color: string
    outline: string
    transition: string
  }
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T
}

const UploadDropzone = ({
  dragOver,
  style,
  getRootProps,
  getInputProps,
}: Props) => {
  return (
    <div
      className={`p-4 rounded-lg mb-2 ${
        dragOver ? 'bg-green-100/50 opacity-50' : 'bg-white'
      }`}
    >
      <div
        {...getRootProps({ style })}
        className={`${
          dragOver ? 'transition ease-in-out delay-75 scale-110' : ''
        }`}
      >
        <input {...getInputProps()} />
        <div className={`${dragOver ? '' : 'animate-pulse'}`}>
          <CloudUploadOutlinedIcon sx={{ fontSize: 68 }} />
        </div>
        <div className="text-lg text-black font-semibold mb-1">
          Drag & drop files/folders or{' '}
          <span className="text-[#089797] cursor-pointer flex justify-center">
            Browse
          </span>
        </div>
        <div className="text-sm text-[#606372]">
          PDF/Img only, file size no more that 15MB
        </div>
      </div>
    </div>
  )
}

export default UploadDropzone
